"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoystickShape = void 0;
var JoystickShape;
(function (JoystickShape) {
    JoystickShape["Circle"] = "circle";
    JoystickShape["Square"] = "square";
    JoystickShape["AxisY"] = "axisY";
    JoystickShape["AxisX"] = "axisX";
})(JoystickShape = exports.JoystickShape || (exports.JoystickShape = {}));
//# sourceMappingURL=shape.enum.js.map